export default __webpack_public_path__ + "static/media/logo.d41d1d78.png";